import React from 'react';
import { Switch } from '../ui/switch';
import { ShieldAlert } from 'lucide-react';
import { useReviewMode, REVIEW_MODE_SUMMARY } from '../../lib/review-mode';

// The single App Store / Play Store review switch as a full-width card.
// The same switch also lives in the admin header (ReviewModePill); both
// share state through useReviewMode.
export default function AppStoreReviewSetting({ onChange }) {
  const { on, saving, setMode } = useReviewMode();

  if (on === null) return null;

  const toggle = async (value) => {
    const next = await setMode(value);
    if (next !== null) onChange?.(next);
  };

  return (
    <div
      className={
        'flex items-center justify-between gap-4 rounded-2xl border p-4 md:p-5 transition-colors '
        + (on
          ? 'border-[var(--adm-brand-ring)] bg-[var(--adm-brand-soft)]'
          : 'border-[var(--adm-border)] bg-[var(--adm-surface)]')
      }
      data-testid="app-store-review-card"
    >
      <div className="flex items-start gap-3 min-w-0">
        <div className={
          'flex h-10 w-10 flex-none items-center justify-center rounded-xl '
          + (on ? 'bg-[var(--adm-brand)] text-white' : 'bg-[var(--adm-surface-2)] text-[var(--adm-muted)]')
        }>
          <ShieldAlert className="h-5 w-5" />
        </div>
        <div className="min-w-0">
          <p className="flex flex-wrap items-center gap-2 text-sm font-semibold text-[var(--adm-text)]">
            App Store &amp; Play Store review mode
            <span className={
              'rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider '
              + (on ? 'bg-[var(--adm-brand)] text-white' : 'bg-[var(--adm-surface-2)] text-[var(--adm-muted)]')
            }>
              {on ? 'On' : 'Off'}
            </span>
          </p>
          <p className="mt-1 text-xs leading-relaxed text-[var(--adm-muted)]">
            Turn on before submitting for review, off after approval. {REVIEW_MODE_SUMMARY}
          </p>
        </div>
      </div>
      <Switch
        checked={on}
        disabled={saving}
        onCheckedChange={toggle}
        aria-label="App Store review mode"
        data-testid="app-store-review-switch"
        className="data-[state=checked]:bg-[var(--adm-brand)]"
      />
    </div>
  );
}
